module.exports = __webpack_public_path__ + "hbomaxar-static/media/Selena-Chef.a4f4d734.png";